import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setAssignmentTransferTypes } from 'Store/OrderManagement/AssignmentTransferTypes/AssignmentTransferTypesAction';
import { GET_ASSIGNMENT_TRANSFER_TYPES } from 'Store/OrderManagement/AssignmentTransferTypes/AssignmentTransferTypesType';
import OrderManagementApiService from './OrderManagementApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getAssignmentTransferTypes(): any {
    let payloadData : IPayload = {
        apiType : apiType.OrderManagement,
        endpoint : `orders/transfer/assignmentTransferTypes`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    
    try {

        yield put(globalLoaderText("Fetching Data...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp,payloadData
        );

        yield put(setAssignmentTransferTypes(response));
        yield put(globalLoaderText(""));

    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchgetAssignmentTransferTypes() {
    yield takeEvery(GET_ASSIGNMENT_TRANSFER_TYPES, getAssignmentTransferTypes);
}

export default function* combinedSaga() {
    yield all([
        watchgetAssignmentTransferTypes()
    ])
}
